/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PatientTreatmentQueueIdUpdateEncounterEncounterIdPost$Params {
  id: string;
  encounterId: string;
}

export function patientTreatmentQueueIdUpdateEncounterEncounterIdPost(http: HttpClient, rootUrl: string, params: PatientTreatmentQueueIdUpdateEncounterEncounterIdPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patientTreatmentQueueIdUpdateEncounterEncounterIdPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('encounterId', params.encounterId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PracticeStrictHttpResponse<void>;
    })
  );
}

patientTreatmentQueueIdUpdateEncounterEncounterIdPost.PATH = '/PatientTreatmentQueue/{id}/UpdateEncounter/{encounterId}';
